import React from 'react'
import { cn } from 'lib/utils'
import { Checkbox } from 'components/ui/checkbox'
import { Label } from 'components/ui/label'

export default function CheckBox(props) {
	const { name, label, value, onChange, className } = props

	const convertToDefEventPara = (name, value) => ({
		target: { name, value },
	})

	return (
		<div className={cn('tw-form-control flex items-center gap-2', className)}>
			<Checkbox
				id={name}
				checked={!!value}
				onCheckedChange={checked => onChange(convertToDefEventPara(name, checked))}
			/>
			{label && (
				<Label htmlFor={name} className="cursor-pointer">
					{label}
				</Label>
			)}
		</div>
	)
}
